import { useState } from 'react'

import { API_URL } from '@goodfellas/environment'
import * as Belt from '@goodfellas/graduation'

import { goodfellasApi } from '../apis'
import { useStore } from './store'

export default function editFighterInfo(
  phone: string,
  name: string,
  belt: string,
  beltDegree: number,
  type: string,
  updateFighterData: (
    phoneNumber: string,
    name: string,
    belt: string,
    degree: number,
    type: string,
  ) => void,
) {
  const [isEditingFighter, setIsEditingFighter] = useState(false)

  const [fighterName, setFighterName] = useState(name)
  const normalizedBelt = (Object.values(Belt.Colors) as string[]).includes(belt)
    ? belt
    : Belt.Colors.White
  const [fighterBelt, setFighterBelt] = useState(normalizedBelt)
  const [fighterBeltDegree, setFighterBeltDegree] = useState(beltDegree)
  const [fighterType, setFighterType] = useState(type)
  const fighterPhone = phone
  const userStore = useStore()

  const handleNameChange = (event) => {
    setFighterName(event.target.value)
  }

  const handleBeltChange = (event) => {
    setFighterBelt(event.target.value)
  }

  const handleBeltDegreeChange = (event) => {
    setFighterBeltDegree(parseInt(event.target.value))
  }

  const handleTypeChange = (event) => {
    setFighterType(event.target.value)
  }

  const handleEditFighterClick = () => {
    setIsEditingFighter(true)
  }

  const handleSaveFighterClick = () => {
    updateFighterData(
      fighterPhone,
      fighterName,
      fighterBelt,
      fighterBeltDegree,
      fighterType,
    )
    handleUpdateRecord({
      userPhone: fighterPhone,
      userName: fighterName,
      userBelt: fighterBelt,
      userBeltDegree: fighterBeltDegree,
      userType: fighterType,
    })
    setIsEditingFighter(false)
  }

  const payloadAdapter = (fighter) => {
    return {
      phoneNumber: fighter.userPhone,
      name: fighter.userName,
      belt: fighter.userBelt,
      degree: fighter.userBeltDegree,
      type: fighter.userType,
    }
  }

  async function handleUpdateRecord(fighter) {
    const payload = payloadAdapter(fighter)

    try {
      await goodfellasApi.post(`${API_URL}evaluation/tables`, {
        ...payload,
        groupId: userStore?.group?._id,
      })
    } catch (error) {
      console.error('Error updating data:', error)
    }
  }

  return {
    isEditingFighter,
    fighterName,
    fighterBelt,
    fighterBeltDegree,
    fighterType,
    handleNameChange,
    handleBeltChange,
    handleBeltDegreeChange,
    handleTypeChange,
    handleEditFighterClick,
    handleSaveFighterClick,
    handleUpdateRecord,
  }
}
